var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toast-hub"},_vm._l((_vm.toasts),function(toast,index){return _c('div',{key:index,staticClass:"item",attrs:{"data-type":toast.type.toLowerCase()}},[_vm._v("\n        "+_vm._s(toast.message)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }